import { OidcSecurityService } from 'angular-auth-oidc-client';
import { FormGroupState } from 'ngrx-forms';

/* eslint-disable @angular-eslint/component-class-suffix */
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

import { AuthFacade } from '../../+state/auth.facade';
import { LoginFormValue } from '../../+state/auth.reducer';
import { VERSION } from '@ideapa/app-common';

@Component({
  standalone: false,
  templateUrl: './login.container.html',
  styleUrls: ['./login.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginContainer {
  loginForm$ = this.authFacade.selectLoginForm$;
  userMustResetPassword$ = this.authFacade.selectUserMustResetPassword$;
  loginError$ = this.authFacade.selectAuthError$;

  showLogin = true;

  constructor(
    @Inject(VERSION) public version: string,
    private authFacade: AuthFacade,
    private oidcSecurityService: OidcSecurityService
  ) {
    // this.oidcSecurityService
    //   .checkAuth()
    //   .subscribe(({ isAuthenticated, userData, accessToken, errorMessage }) => {
    //     console.log(isAuthenticated);
    //     console.log(userData);
    //     console.log(accessToken);
    //     console.log(errorMessage);
    //   });
  }

  onSubmit(form: FormGroupState<LoginFormValue>) {
    if (form.isValid) {
      this.authFacade.login(
        form.value.username,
        form.value.password,
        form.value.rememberMe,
        form.value.newPassword
      );
    }
  }

  aadLogin(form: FormGroupState<LoginFormValue>) {
    this.authFacade.loginAAD(form.value.rememberMe);
  }
}
